import React from "react";
import "./ScrollDown.scss";

export default function ScrollDown({ children = null, className = "" }) {
	return (
		<div className={`scrolldown ${className}`}>
			<div class="chevrons">
				<div class="chevrondown"></div>
				<div class="chevrondown"></div>
			</div>
		</div>
	);
}
